export const scrollTop = () => {
  const appElement = document.querySelector(".App");

  appElement?.scrollTo(0, 0);
};

// this (in scrollTo) try-catch block is used to prevent runtime errors in case the selector
// obtained from the url contains invalid characters, such as cyrillic or other
// non-valid symbols

export const scrollTo = (selector: string) => {
  try {
    const element = document.querySelector(selector);
    element?.scrollIntoView({ behavior: "smooth" });
  } catch {}
};
